// src/features/inventory/hooks/useSuppliers.js
import { useState, useCallback } from 'react';
import { suppliersAPI } from '../services/suppliers';
import { useApi } from '../../../hooks/api/useApi';

export function useSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [currentSupplier, setCurrentSupplier] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchSuppliers = useCallback(async () => {
    const result = await execute(() => suppliersAPI.getAll());
    if (result.success) {
      setSuppliers(result.data.data || []);
    }
    return result;
  }, [execute]);

  const fetchSupplierById = useCallback(async (supplierId) => {
    const result = await execute(() => suppliersAPI.getById(supplierId));
    if (result.success) {
      setCurrentSupplier(result.data.data);
    }
    return result;
  }, [execute]);

  const createSupplier = useCallback(async (data) => {
    const result = await execute(() => suppliersAPI.create(data));
    if (result.success) {
      setSuppliers(prev => [result.data.data, ...prev]);
    }
    return result;
  }, [execute]);

  const updateSupplier = useCallback(async (supplierId, data) => {
    const result = await execute(() => suppliersAPI.update(supplierId, data));
    if (result.success) {
      const updated = result.data.data;
      setSuppliers(prev => prev.map(s => s.supplier_id === supplierId ? updated : s));
      setCurrentSupplier(updated);
    }
    return result;
  }, [execute]);

  const deleteSupplier = useCallback(async (supplierId) => {
    const result = await execute(() => suppliersAPI.remove(supplierId));
    if (result.success) {
      setSuppliers(prev => prev.filter(s => s.supplier_id !== supplierId));
    }
    return result;
  }, [execute]);

  return {
    suppliers,
    currentSupplier,
    loading,
    error,
    clearError,
    fetchSuppliers,
    fetchSupplierById,
    createSupplier,
    updateSupplier,
    deleteSupplier,
  };
}
